import { call, put } from 'redux-saga/effects';
import * as R from 'remeda';
import { suggestionActions } from 'store/data/suggestion';
import { createSuggestion } from 'store/glue/operation/createSuggestion';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as improvementsActions from './actions';

// Persists a locally-created (temporary) suggestion to the API via the
// createSuggestion operation, then swaps the temporary ID for the
// server-assigned one. Returns early if the operation returns undefined
// (missing tenantId or feature access — see createSuggestion operation
// for guards).
export function* startSaveSuggestionSaga(
  action: ActionType<typeof improvementsActions.startSaveSuggestion>,
) {
  function* saga() {
    const temporarySuggestion = action.payload;

    const createdSuggestion: Data.Suggestion | undefined = yield call(
      createSuggestion,
      { suggestion: temporarySuggestion },
    );
    if (!R.isDefined(createdSuggestion)) return;

    yield put(
      improvementsActions.setSelectedSuggestionId(createdSuggestion.id),
    );
    // Remove the temporary placeholder now that the real entity is in the store
    yield put(suggestionActions.remove(temporarySuggestion.id));
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
